import React, { useEffect, useState, useCallback } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookmark } from "@fortawesome/free-regular-svg-icons";
import data from "services/data";
import http from "utils/http";
import logger from "utils/logger";

const StyledPluginDetail = styled.div`
  /* align-self: center; */
  /* width: fit-content; */
  display: flex;
  flex-direction: column;
  row-gap: 7px;
  border: 1px solid ${({ theme }) => theme.borderGray};
  border-radius: 6px;
  padding: 20px 48px 20px 24px;
  position: relative;
`;

const StyledName = styled.div`
  display: flex;
  column-gap: 10px;
  color: ${({ theme }) => theme.dark};
  font-size: ${({ theme }) => theme.fontSize.normal};
`;

const StyledNameContent = styled.div`
  color: ${({ theme }) => theme.dark};
  line-height: 1.25;
  font-weight: 600;
  word-break: break-all;
`;

const StyledAliasName = styled.div`
  display: flex;
  column-gap: 10px;
  color: ${({ theme }) => theme.black};
  font-size: ${({ theme }) => theme.fontSize.lsmall};
`;

const StyledAliasNameContent = styled.div`
  color: ${({ theme }) => theme.black};
  line-height: 1.25;
  font-weight: 600;
  word-break: break-all;
`;

const StyledAppId = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
  color: ${({ theme }) => theme.black};
  font-size: ${({ theme }) => theme.fontSize.lsmall};
`;

const StyledAppIdContent = styled.div`
  color: ${({ theme }) => theme.dark};
  line-height: 1.25;
  word-break: break-all;
  font-size: ${({ theme }) => theme.fontSize.lsmall};
`;

const StyledInfo = styled.div`
  color: ${({ theme }) => theme.infoGray};
  line-height: 1.5;
  word-break: break-word;
  font-size: ${({ theme }) => theme.fontSize.small};
  border-left: solid 5px ${({ theme }) => theme.quoteBorderGray};
  padding: 5px 5px 5px 10px;
`;

const StyledPath = styled.div`
  color: ${({ theme }) => theme.infoGray};
  word-break: break-word;
  line-height: 1.5;
  font-size: ${({ theme }) => theme.fontSize.lsmall};
`;

const StyledIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.quoteGray};
  position: absolute;
  right: 16px;
  top: -1px;
`;

const PluginDetail = ({ appId = "", pluginInfo = null }) => {
  if (!pluginInfo) {
    return <StyledPluginDetail>未找到该插件</StyledPluginDetail>;
  }

  if (appId !== pluginInfo.appId) {
    return (
      <StyledPluginDetail>
        传入的插件名与查询到的插件名不匹配，{appId}, {pluginInfo?.appId}
      </StyledPluginDetail>
    );
  }
  return (
    <StyledPluginDetail>
      <StyledIcon icon={faBookmark} size="lg" />
      <StyledName>
        Name:
        <StyledNameContent>{pluginInfo.module}</StyledNameContent>
      </StyledName>
      <StyledAliasName>
        Alias:
        <StyledAliasNameContent>{pluginInfo.aliasName}</StyledAliasNameContent>
      </StyledAliasName>
      <StyledAppId>
        AppID:
        <StyledAppIdContent>{pluginInfo.appId}</StyledAppIdContent>
      </StyledAppId>
      <StyledPath>{pluginInfo.installPath}</StyledPath>
      <StyledInfo>{pluginInfo.info}</StyledInfo>
    </StyledPluginDetail>
  );
};

export default PluginDetail;
